import { Box, Button, Container, Group, Stack, Title } from "@mantine/core";
import { Link, useParams } from "react-router-dom";
import UserNewFeed, { NewsItem } from "components/profile/UserNewFeed";

/**
 * FranchiseNews
 *
 * Franchise-scoped news page. Route: /franchises/:franchiseId/news
 * - Provides a back button to return to the franchise profile
 * - Reuses the UserNewFeed component; later wire items from API by franchiseId
 */
export default function FranchiseNews() {
  const { franchiseId } = useParams<{ franchiseId: string }>();

  // TODO: Replace with useFranchiseNewsQuery(franchiseId)
  const items: NewsItem[] = [
    { id: "fn1", title: "New sponsorship announced", postedAt: new Date().toISOString(), excerpt: "Moist Esports partners with Acme Co." },
    { id: "fn2", title: "Content creator joins org", postedAt: new Date(Date.now() - 1000 * 60 * 60 * 36).toISOString(), excerpt: "Welcome our newest creator!" },
  ];

  const backHref = `/franchises/${franchiseId ?? ""}`;

  return (
    <Container size="lg" p="md">
      <Stack gap="md">
        <Group justify="space-between" align="center">
          <Title order={3}>Franchise News</Title>
          {/* Single reliable back action: explicit link back to the franchise profile */}
          <Button component={Link} to={backHref} variant="light">
            Back to Franchise
          </Button>
        </Group>

        <Box>
          <UserNewFeed title="Franchise News Feed" items={items} />
        </Box>
      </Stack>
    </Container>
  );
}
